// src/components/gestionEvento/siembraManager/SessionSiembra.js
import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SiembraTable from './SiembraTable';

export default function SessionSiembra({
  session,
  pruebasConfig,
  onConfigChange,
  selectedRows,
  onSelectRow,
}) {
  const schedules = session.schedules || [];

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="subtitle1">
          Sesión {session.number}: {session.name}{' '}
          {session.date ? `- ${session.date}` : ''}{' '}
          {session.startTime ? ` ${session.startTime}` : ''}
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        {schedules.length === 0 ? (
          <Typography variant="body2">
            No hay items (schedules) en esta sesión.
          </Typography>
        ) : (
          <SiembraTable
            schedules={schedules}
            pruebasConfig={pruebasConfig}
            onConfigChange={onConfigChange}
            selectedRows={selectedRows}
            onSelectRow={onSelectRow}
          />
        )}
      </AccordionDetails>
    </Accordion>
  );
}
